import { React, useState } from 'react';
import AnchorAdv from '../../../UI/AnchorAdv.js';
import AnchorExternal from '../../../UI/AnchorExternal.js';
import mainimage from '../../../../assets/SNR_BNFTS_V1/img/mainimage4.jpg';
import entertainment from '../../../../assets/SNR_BNFTS_V1/img/entertainment.jpg';
import carInsurance from '../../../../assets/SNR_BNFTS_V1/img/car-insurance.jpg';
import slashcellphone from '../../../../assets/SNR_BNFTS_V1/img/slashcellphone.jpg';
import brandedsurveys from '../../../../assets/SNR_BNFTS_V1/img/brandedsurveys.jpg';
import hearTB8811 from '../../../../assets/SNR_BNFTS_V1/img/hearTB8811.jpg';
import health from '../../../../assets/SNR_BNFTS_V1/img/health.jpg';
import image4 from '../../../../assets/SNR_BNFTS_V1/img/image4.png';
import SNR_BNFTS_V1Footer from './SNR_BNFTS_V1Footer.js';

const SNR_BNFTS_V1_Main = ({ heading, textContent }) => {
  const [showAdvertiser, setShowAdvertiser] = useState('hide');
  const modalClick = (clickValue) => {
    var modalAction = clickValue;
    switch (modalAction) {
      case 'showAdvertiser': {
        setShowAdvertiser('show');
        break;
      }
      case 'exitAdvertiser': {
        setShowAdvertiser('hide');
        break;
      }
    }
  };
  return (
    <>
      <main className="container">
        <article>
          <div className="text-center mb-4">
            <h1 className="fw-bold">
              7 Amazing Benefits Seniors Are Entitled to in 2025
            </h1>
            <p className="h4 fst-italic mt-2 sb">(But Often Forget to Claim)</p>
            <p className="byline mt-3">
              by: Lisa Sullivan | April 28, 2025 |{' '}
              <a
                style={{ cursor: 'pointer' }}
                data-bs-toggle="modal"
                data-bs-target="#advertiserDisclosureModal"
                className="text-decoration-none text-muted"
                onClick={() => modalClick('showAdvertiser')}
              >
                ADVERTISER DISCLOSURE
              </a>
            </p>
          </div>

          <figure className="text-center mb-3">
            <img
              src={mainimage}
              className="img-fluid rounded"
              alt="Portrait of a senior man looking thoughtful"
            />
          </figure>

          <div className="article-body">
            <p>
              Did you know many seniors are overpaying for essentials like car
              insurance, prescriptions, and groceries? It's not because the
              deals aren't out there —{' '}
              <strong className="fw-bold">
                it's because no one's shouting about them!
              </strong>
            </p>
            <p>
              The truth is, tons of companies offer hidden discounts for those
              over 55 — you just have to know to ask.
            </p>
            <p>
              To help you keep more money in your pocket, we've rounded up the
              best discounts and benefits available in 2025 — some could save
              you up to £6,100!
            </p>
            <p>
              And we're not just talking about the usual restaurant and shop
              deals — these are serious savings on the things seniors use and
              need most.
            </p>
            <p>
              <strong className="fw-bold">Heads up:</strong> many of these
              offers are online exclusives just for our readers — so don't miss
              out!
            </p>
          </div>
        </article>

        <hr className="my-4" />

        <section className="benefit-section ">
          <h2 className="fw-bold benefit-heading mb-3">
            1. Enjoy entertainment for less
          </h2>
          <figure className="mb-3">
            <img
              src={entertainment}
              className="img-fluid rounded"
              alt="Happy senior couple watching a movie with popcorn"
            />
          </figure>
          <p className="mt-3">
            Who doesn't want to have fun and save money? Enjoy outings even more
            with senior discounts on various entertainment options!
          </p>
          <div className="benefit-list mt-4">
            <p className="benefit-item mb-2">
              <strong className="fw-bold">Odeon Silver Cinema</strong> - Tickets
              are from £3.50 and include tea, coffee, and biscuits.
            </p>
            <p className="benefit-item mb-2">
              <strong className="fw-bold">Kindle E-Books:</strong> Seniors can
              borrow eBooks and audiobooks for free by linking their library
              card to the service, allowing them to read on Kindle devices or
              apps.
            </p>
            <p className="benefit-item mb-2">
              <strong className="fw-bold">Ticketmaster:</strong> Seniors 65+
              enjoy reduced prices on tickets (discount varies per ticket)
            </p>
            <p className="benefit-item mb-2">
              <strong className="fw-bold">Museums:</strong> Seniors 50+ enjoy
              discounts and special offers at museums. (discount varies
              depending on museum)
            </p>
          </div>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            2. Reclaim Undisclosed Car Finance Commissions
          </h2>
          <figure className="mb-3">
            <AnchorAdv dataId="PARA_IMG_LINKS_3">
              <img
                src={carInsurance}
                className="img-fluid rounded"
                alt="Happy senior couple waving from a convertible car"
              />
            </AnchorAdv>
          </figure>
          <p className="mt-3">
            Many seniors ended up paying too much for their car finance. What
            we're learning is that dealers appeared to have worked{' '}
            <strong className="fw-bold">with</strong> the lenders to
            artificially inflate interest rates and pocketing the margin...
          </p>
          <p>
            This has been happening since 2007, which means seniors especially
            have a huge potential refund due. Roughly 90% of all cars purchased
            in the UK are on finance and nearly all of them are thought to have
            had secret commissions arranged between dealers and lenders.{' '}
            <strong className="fw-bold">
              This means seniors could be owed over £6,000.
            </strong>
          </p>
          <p>
            Here's how to quickly see if you were secretly overcharged and due a
            refund (takes maybe a couple minutes):
          </p>
          <ol className="mt-3 mb-3 ps-4">
            <li>
              Pull up
              <AnchorAdv
                dataId="PARA_TEXT_LINKS_5"
                className="text-decoration-none"
              >
                {' '}
                <strong className="fw-bold">findcarfinance.online</strong>{' '}
              </AnchorAdv>{' '}
              – it's a free site that will lookup all your car finance
            </li>
            <li>Answer the questions on the page</li>
            <li>
              It'll confirm all your loans and start your refund all online.
            </li>
          </ol>
          <p>
            That's literally it. You'll likely save yourself a bunch of money.
          </p>
          <p className="mt-3 fw-bold">
            <AnchorAdv
              dataId="PARA_TEXT_LINKS_1"
              className="text-decoration-none"
            >
              Lookup Your Name Online to Find Out If You're Owed £6,000 or More
              &gt;&gt;
            </AnchorAdv>
          </p>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            3. Slash your mobile phone bill
          </h2>
          <figure className="mb-3">
            <img
              src={slashcellphone}
              className="img-fluid rounded"
              alt="Senior citizen happily using a mobile phone"
            />
          </figure>
          <p className="mt-3">
            Did you know that many major wireless companies provide special
            discounts for senior citizens? These savings can quickly add up!
          </p>
          <div className="benefit-list mt-4">
            <p className="benefit-item mb-2">
              <strong className="fw-bold">SMARTY:</strong> Offers unlimited
              calls and texts with 4GB of data for £5/month, no contract
              required.
            </p>
            <p className="benefit-item mb-2">
              <strong className="fw-bold">iD Mobile:</strong> Provides 30GB of
              data plus unlimited calls and texts for £8/month.
            </p>
            <p className="benefit-item mb-2">
              <strong className="fw-bold">giffgaff:</strong> Features flexible
              plans starting at £6/month with no contracts.
            </p>
          </div>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            4. Get Paid Up to £500/Month Just for Sharing Your Honest Opinion
          </h2>
          <figure className="mb-3">
            <img
              src={brandedsurveys}
              className="img-fluid rounded"
              alt="Person taking an online survey on a laptop or tablet"
            />
          </figure>
          <p className="mt-3">
            Brands want to hear your opinion to help inform their business
            decisions on everything from products and services to logos and ads
            — and they're willing to pay you up to £500 a month for it.
          </p>
          <p>
            A free site called{' '}
            <AnchorExternal
              extURL="https://toppaidsurveys.co.uk/"
              dataId="EXT_LINK_1"
              className="text-decoration-none fw-bold"
            >
              TopPaidSurveys.co.uk
            </AnchorExternal>{' '}
            will pay you up to £25* per survey for sharing your thoughts with
            their brand partners. Taking three quick surveys a day could earn up
            to £500 each month.
          </p>
          <p>
            Most surveys take only a couple of minutes, and you'll get paid just
            for sharing your opinions.
          </p>
          <p>
            <AnchorExternal
              extURL="https://toppaidsurveys.co.uk/"
              dataId="EXT_LINK_2"
              className="text-decoration-none fw-bold text-danger"
            >
              Set up your account and start getting paid to take surveys
            </AnchorExternal>
            . Plus, right now, you'll get a free 100-point welcome bonus just
            for becoming part of the community.
          </p>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            5. Earn as Much as £1K/Month Doing Simple Online Tasks
          </h2>
          <figure className="mb-3">
            <img
              src={hearTB8811}
              className="img-fluid rounded"
              alt="Person using a computer for online tasks"
            />
          </figure>
          <p className="mt-3">
            Is there such a thing as easy money? If you know your way around the
            web, there certainly is.
          </p>
          <p>
            That's because data is currency these days, and many companies are
            willing to pay cash for it — up to £1,000 per month.
          </p>
          <p>
            Finding these companies can be time-consuming on your own. But a
            company called{' '}
            <AnchorExternal
              extURL="https://www.thepennyhoarder.com/overflow-gamessurvey2/"
              dataId="EXT_LINK_3"
              className="text-decoration-none fw-bold text-danger"
            >
              {' '}
              Freecash{' '}
            </AnchorExternal>{' '}
            has compiled all sorts of quick cash tasks from about a dozen
            advertisers and market research companies thirsty for more data.
            Freecash has paid out over £13 million to users since 2019.
          </p>
          <p>
            You can pick and choose your tasks and complete them at your
            convenience. The coins you earn from each completed task can be
            converted into things like Visa gift cards, Amazon gift cards,
            cryptocurrency or cold-hard PayPal cash.
          </p>
          <p>
            Signing up for a Freecash account is easy and there's no minimum
            amount you need to earn before you can cash out. And if you've got
            enough free time on your hands, you can join the ranks of Freecash
            users making more than £1,000 a month in extra cash.
          </p>
          <p>
            <AnchorExternal
              extURL="https://www.thepennyhoarder.com/overflow-gamessurvey2/"
              dataId="EXT_LINK_4"
              className="text-decoration-none fw-bold text-danger"
            >
              {' '}
              Sign up here{' '}
            </AnchorExternal>
            to see how much you could earn.
          </p>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            6. Take advantage of health discounts
          </h2>
          <figure className="mb-3">
            <img
              src={health}
              className="img-fluid rounded"
              alt="Healthcare professional assisting a senior citizen"
            />
          </figure>
          <p className="mt-3">
            British seniors are overspending on their healthcare needs. From
            routine medications to essential wellness products, the costs can
            quickly add up, creating financial strain for many.
          </p>
          <p>
            Fortunately, there are numerous programs designed specifically to
            help seniors manage these costs more effectively:
          </p>
          <ul className="list-unstyled mt-3 ps-2">
            <li className="mb-3">
              <strong className="fw-bold">Boots Over 60s Rewards:</strong>
              <ul className="list-unstyled ps-4 mt-1">
                <li>
                  ∘ Earn 8 Advantage Card points per £1 spent on Boots brands
                  and selected exclusives.
                </li>
                <li>∘ Receive 25% off glasses and prescription sunglasses.</li>
                <li>∘ Get 15% off hearing aids.</li>
              </ul>
            </li>
            <li className="mb-3">
              <strong className="fw-bold">LloydsPharmacy Online Doctor:</strong>
              <ul className="list-unstyled ps-4 mt-1">
                <li>
                  ∘ Offers exclusive senior discounts on various healthcare
                  products and services, including treatments for weight loss,
                  erectile dysfunction, and more.
                </li>
              </ul>
            </li>
            <li className="mb-3">
              <strong className="fw-bold">Specsavers:</strong>
              <ul className="list-unstyled ps-4 mt-1">
                <li>∘ Provides free NHS-funded eye tests for those over 60.</li>
                <li>
                  ∘ Offers 25% off glasses and lenses when purchasing frames
                  priced at £69 or more.
                </li>
              </ul>
            </li>
          </ul>
        </section>

        <hr className="my-4" />

        <section className="benefit-section">
          <h2 className="fw-bold benefit-heading mb-3">
            7. Enjoy cheaper transportation and travel costs
          </h2>
          <figure className="mb-3">
            <img
              src={image4}
              className="img-fluid rounded"
              alt="Seniors traveling with luggage at an airport or train station"
            />
          </figure>
          <p className="mt-3">
            If you enjoy exploring new places, taking vacations, or visiting
            family, always remember to check for travel discounts. Travelers
            aged 55+ can unlock additional perks and savings from the various
            travel providers. Here are a few we know about:
          </p>
          <div className="travel-discounts mt-4">
            <div className="mb-4">
              <p className="fw-bold">National Express Senior Coachcard:</p>
              <ul className="ps-4">
                <li>
                  <strong className="fw-bold">Eligibility:</strong> Available to
                  individuals aged 60 and over.
                </li>
                <li>
                  <strong className="fw-bold">Benefits:</strong> Provides 1/3
                  off standard and fully flexible fares.
                </li>
                <li>
                  <strong className="fw-bold">Cost:</strong> £15 per year.
                </li>
              </ul>
            </div>
            <div className="mb-4">
              <p className="fw-bold">Senior Railcard:</p>
              <ul className="ps-4">
                <li>
                  <strong className="fw-bold">Eligibility:</strong> Available to
                  individuals aged 60 and over.
                </li>
                <li>
                  <strong className="fw-bold">Benefits:</strong> Offers 1/3 off
                  most rail fares across Britain, including Standard and First
                  Class, Anytime, Off-Peak, and Advance fares.
                </li>
                <li>
                  <strong className="fw-bold">Cost:</strong> £35 for one year or
                  £70 for three years.
                </li>
                <li>
                  <strong className="fw-bold">Additional Perks:</strong> Access
                  to special offers on attractions and dining.
                </li>
              </ul>
            </div>
            <div className="mb-4">
              <p className="fw-bold">
                British Airways AARP Partnership:Eligibility: AARP members
                (membership is open to individuals aged 50 and over, including
                UK residents).
              </p>
              <ul className="ps-4">
                <li>$65 off economy and premium economy fares.</li>
                <li>$200 off business class fares.</li>
                <li>
                  Discounts apply to round-trip flights originating from the
                  U.S. to over 130 destinations worldwide.
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div
          className={`modal popup-modal ${showAdvertiser}`}
          id="advertiserDisclosureModal"
          tabIndex={-1}
          aria-labelledby="advertiserDisclosureModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="advertiserDisclosureModalLabel">
                  Advertiser Disclosure
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => modalClick('exitAdvertiser')}
                />
              </div>
              <div className="modal-body">
                <p>
                  This site is a free online resource that strives to offer
                  helpful content and comparison features to our visitors. We
                  accept advertising compensation from companies that appear on
                  the site, which impacts the location and order in which brands
                  (and/or their products) are presented, and also impacts the
                  score that is assigned to it. Company listings on this page DO
                  NOT imply endorsement. We do not feature all providers on the
                  market. Except as expressly set forth in our Terms of Use, all
                  representations and warranties regarding the information
                  presented on this Page are disclaimed. The information,
                  including pricing, which appears on this site is subject to
                  change at any time. We are not an investment advisor,
                  financial advisor, loan broker, insurance producer, or
                  insurance broker. We do not and cannot guarantee the accuracy
                  or applicability of any information in regard to your
                  individual circumstances. We encourage you to seek
                  personalized advice from qualified professionals regarding
                  specific investment issues.
                </p>
                <p>
                  We value your privacy. We work with trusted partners to
                  provide relevant advertising based on information about your
                  use of Saavy Finance's and third-party websites and
                  applications. This includes, but is not limited to, sharing
                  information about your web browsing activities with Meta
                  (Facebook) and Google. All of the web browsing information
                  that is shared is anonymized. To learn more, click on our
                  Privacy Policy link.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => modalClick('exitAdvertiser')}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <SNR_BNFTS_V1Footer></SNR_BNFTS_V1Footer>
      </main>
    </>
  );
};
export default SNR_BNFTS_V1_Main;
